@if (
  !(selectedShapes$ | async) &&
  !(isLofiReportAvailable$ | async) &&
  (!(summaryStatsReportAvailable$ | async) ||
    !(showSummaryStatsReport$ | async))
) {
  <div class="atlas-panel-body" i18n="@@selectShapeMessage">
    Please select a shape to view a report
  </div>
}
<mat-divider></mat-divider>

<div class="atlas-panel-body">
  <atlas-locator-reports-panel></atlas-locator-reports-panel>
</div>

<mat-divider></mat-divider>
<atlas-locator-reports-panel-buttons></atlas-locator-reports-panel-buttons>
